<template>
    <div>
        <tr-text class="label" v-bind="props.label" :tracker="tracker"
                @edit-tr="$emit('edit-tr', $event)" v-if="showLabel" />
        <select>
            <option v-for="opt in children" :key="opt.props.value.val">
                <tr-display v-bind="opt.props.label" />
            </option>
        </select>
        &nbsp;
        <b-button size="is-small"  v-if="props.items_have_t9n"
            @click="itemTrOpen = !itemTrOpen"
            :disabled="translateableEntries == 0"
            icon-left="globe-europe"
            :icon-right="!itemTrOpen ? 'caret-down' : 'caret-up'"
            >
        </b-button>
        <b-collapse :open.sync="itemTrOpen" has-modal-card>
            <i18n-item-translation-modal v-if="props.items_have_t9n"
                :props="props"
                :children="children"
                :tracker="tracker"
                @edit-tr="$emit('edit-tr', $event)"
                @tr-open-modal="openCollapse"

            ></i18n-item-translation-modal>
        </b-collapse>
    </div>
</template>

<script>
import TrText                   from "@/components/translation/TrText"
import TrDisplay                from "@/components/translation/TrDisplay"
import I18nItemTranslationModal from "@/components/i18n/I18nItemTranslationModal"

export default {
    name:     "I18nCombobox",
    components: {TrText, TrDisplay, I18nItemTranslationModal},
    props: {
        tracker: Array,
        index: Number,
        children: Array,
        props: Object,
        showLabel: {default: true}
    },
    data () {
        return {
            itemTrOpen: false
        }
    },
    computed : {
        translateableEntries () {
            let count = 0
            for (let i = 0; i < this.children.length; i++) {
                if (this.children [i].props.label.t9n) count = count + 1
            }
            return count
        }
    },
    methods : {
        openCollapse (trText) {
            console.log (trText.elementId)
            this.itemTrOpen = true
            setTimeout (() =>
                this.$scrollTo ("#" + trText.elementId, 100, {offset : -160})
                , 100)
        }
    }
}
</script>

<style>
    .label {
        width:   30%;
        display: inline-block;
    }
</style>